/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DataChatService } from 'src/chatbot/service/dataChat.service';

@Component({
  selector: 'chat-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './chatInput.component.html',
  styleUrl: './chatInput.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatInputComponent {
  @Output() keydownEvent = new EventEmitter<Event>();
  @Input() chatForm!: FormGroup;
  public dataChat = inject(DataChatService);
  public isStreaming = computed(() => this.dataChat.isStreaming())

  public inputText: any;

  public message = computed(() => {
    switch(this.dataChat.lang()){
      case 'es': return 'Escribe un mensaje...'
      case 'en': return 'Write a message...'
      case 'fr': return 'Écris un message...'
      case 'it': return 'Scrivi un messaggio...'
      case 'de': return 'Schreibe eine Nachricht...'
      default: return 'Write a message...'
    }
  });

  onKeyPress(){
    this.dataChat.inputText.set(this.inputText)
  }

  getUserInputControl(): FormControl {
    return this.chatForm?.get('userInput') as FormControl;
  }

  emitKeyDownEvent(event: Event){
    this.keydownEvent.emit(event)
  }

}
